import { createContext } from 'react';

import {
  SalesOrderCommissioningReportItem,
  SalesOrderCommissioningReportItems,
} from '@totem/components/salesOrders/commissioning/types';

interface Context {
  loading: boolean;
  reportData: SalesOrderCommissioningReportItems;
  totalRecords: number;
  searchText: string;
  setSearchText: (val: string) => void;
  onAction: (
    action: string,
    record: SalesOrderCommissioningReportItem,
    tab?: string,
  ) => void;
  refetch: () => void;
}

const CommissioningReportContext = createContext<Context>({
  loading: false,
  reportData: [],
  totalRecords: 0,
  searchText: '',
  setSearchText: () => {},
  onAction: () => {},
  refetch: () => {},
});

export default CommissioningReportContext;
